import React, { memo, useEffect } from 'react';
import NotificationAPI from 'notificationapi-js-client-sdk';
import { PopupPosition } from 'notificationapi-js-client-sdk/lib/interfaces';
import { styled, IconButton, alpha } from '@mui/material';
import { getEnvironment, getServerType } from '../../../../../../utils';

const NotificationButton = styled(IconButton)(({ theme }) => ({
    height: '42px',
    width: '42px',
    borderRadius: '4.5px',
    '& .icon-bell-o': {
        color: alpha(theme.palette.secondary.main, 0.8),
        height: '32px',
        width: '32px',
        fontWeight: 800,
    },
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
}));

const NotificationAPIButton = memo(({ userId }) => {
    useEffect(() => {
        if (userId) {
            const notificationApiUserId = `${userId}${getEnvironment(window.location.hostname)}${getServerType(window.location.hostname)}`;
            const notificationApi = new NotificationAPI({
                clientId: process.env.REACT_APP_NOTIFICATION_API_CLIENT_ID,
                userId: notificationApiUserId,
            });
            notificationApi.showInApp({
                root: 'notification_api_id',
                popupPosition: PopupPosition.BottomLeft,
            });
        }
    });

    return <NotificationButton id="notification_api_id" />;
});

export default NotificationAPIButton;
